export const containerClassName = `
  h-full w-full
  overflow-y-hidden 
  flex flex-col
  md:pt-[20px]
`

export const bodyContainerClassName = `
  flex-grow 
  overflow-y-hidden 
  flex flex-col
  mt-4
`

export const chatHistoryListContainerClassName = `
  flex-grow 
  overflow-y-auto 
  chat-history-logs-container
  pl-[20px] pb-[20px] mr-1
  
`

export const headerContainerClassName = `
  flex items-center justify-between 
  px-[20px]
`

export const headerActionsContainerClassName = `
  flex items-center 
  md:gap-x-[20px] gap-x-[12px]
`

export const headerActionContainerClassName = `
  cursor-pointer
`

export const headingContainerClassName = `
  flex items-center
  md:mb-[20px] gap-x-2
`

export const headingTextClassName = `
  text-md-semibold truncate
`

export const threadCardContainerClassName = `
  p-[10px] pl-[8px] gap-x-2
  flex items-center  
  cursor-pointer
`

export const threadNameTextClassName = `
  text-sm-medium truncate
`
